import { IfRuleGroup } from '../classes/if-gate/if-rule-group';
import { IfRule } from '../interfaces/if-gate/if-rules';

export function IsRuleGroup(ruleItem: IfRuleGroup | IfRule) {
	return ruleItem instanceof IfRuleGroup || Object.hasOwn(ruleItem, 'ruleGroup');
}

export function IsRule(ruleItem: IfRuleGroup | IfRule) {
	return ruleItem instanceof IfRule || Object.hasOwn(ruleItem, 'operator');
}

export function GetTotalRulesAndGroups(ruleGroup: IfRuleGroup) {
	let groupCount = 1;
	let ruleCount = 0;
	for (const rule of ruleGroup.ruleGroup) {
		if (IsRuleGroup(rule)) {
			// Recursively count rules in nested groups
			groupCount++;
			ruleCount += CountTotalRules(rule as IfRuleGroup);
		} else {
			// Count individual rules
			ruleCount++;
		}
	}
	return { groupCount, ruleCount };
}

export function CountTotalRuleGroups(ruleGroup: IfRuleGroup): number {
	let count = 1; // Count the current group
	for (const rule of ruleGroup.ruleGroup) {
		if (IsRuleGroup(rule)) {
			// Recursively count nested groups
			count += CountTotalRuleGroups(rule as IfRuleGroup);
		}
	}
	return count;
}

export function CountTotalRules(ruleGroup: IfRuleGroup): number {
	let count = 0;
	for (const rule of ruleGroup.ruleGroup) {
		if (IsRuleGroup(rule)) {
			// Recursively count rules in nested groups
			count += CountTotalRules(rule as IfRuleGroup);
		} else {
			// Count individual rules
			count++;
		}
	}
	return count;
}

export function GetCurrentGroupStats(ruleGroup: IfRuleGroup): {
	groupCount: number;
	ruleCount: number;
} {
	return {
		groupCount: ruleGroup.ruleGroup.filter(x => IsRuleGroup(x)).length,
		ruleCount: ruleGroup.ruleGroup.filter(x => IsRule(x)).length,
	};
}
